import React, { useState, useContext } from 'react';
import { PropTypes } from 'prop-types';

import Config from '@skin_config';
import { PopupContext } from '@app/dev/contexts/popup';
import { useTranslation } from '@common/hooks/translation';
import { depositMethods } from '@app/dev/constants/depositMethods';

import { getAuthData } from '@common/helpers/auth';
import LoaderButton from '@common/components/loaderButton';
import { useSelector } from 'react-redux';
import DepositAmountForm from '../../pieces/depositAmountForm';
import DepositServicePix from './service';
import DepositQRIframe from '../../pieces/depositQRIframe';
import { signInPopupType } from '@app/dev/helpers/user';

const DepositContentPix = ({ type }) => {
  const t = useTranslation();
  const [{ closePopup, openPopup }] = useContext(PopupContext);

  const [amount, setAmount] = useState('');
  const [errorText, setErrorText] = useState('');
  const [forwardUrl, setForwardUrl] = useState(null);
  const [loading, setLoading] = useState(false);
  const user = useSelector((state) => state.user);
  const { loggedIn, loggedInByRFID } = user;
  const userLoggedin = loggedInByRFID || loggedIn;

  const confirmAmount = async () => {
    const { currency } = getAuthData();
    const { minAmount = 0 } = Config.depositMethods.find((method) => method.type === type);

    if (!+amount) return;

    if (+amount < minAmount) return setErrorText(['Minimum amount should be {1}', `${minAmount} ${currency}`]);

    setLoading(true);

    const response = await DepositServicePix.createOrder(+amount);

    setLoading(false);

    if (response.errorText) setErrorText(response.errorText);
    else setForwardUrl(response.forwardUrl);
  };

  const back = () => {
    setErrorText('');
    setForwardUrl(null);
  };

  return (
    <div className="popup-content popup-small">
      <h3 className="popup-title">{t('Deposit with {1}', depositMethods[type].name)}</h3>

      {forwardUrl ? (
        <>
          <DepositQRIframe
            name={depositMethods[type].name}
            url={forwardUrl}
          />
          <div className="popup-actions">
            <button type="button" onClick={back} className="popup-cancel-button">{t('Back')}</button>
            <button type="button" onClick={closePopup} className="popup-confirm-button">{t('Done')}</button>
          </div>
        </>
      ) : (
        <>
          <DepositAmountForm
            amount={amount}
            onChange={setAmount}
            errorText={errorText}
          />
          <div className="popup-actions">
            <button type="button" onClick={closePopup} className="popup-cancel-button">{t('Cancel')}</button>
            {!userLoggedin ? (
              <button
                type="button"
                className="popup-confirm-button"
                onClick={() => openPopup(signInPopupType)}
              >
                {t('login')}
              </button>
            ) : (
              <LoaderButton
                loading={loading}
                onClick={confirmAmount}
                className="popup-confirm-button"
              >
                {t('Next')}
              </LoaderButton>
            )}
          </div>
        </>
      )}
    </div>
  );
};

DepositContentPix.propTypes = {
  type: PropTypes.string.isRequired,
};

export default DepositContentPix;
